export default __webpack_public_path__ + "static/media/mii.84f92ea0.png";